import React from "react";
import { Link } from "react-router-dom";
import background from '../assets/OBJECTS.png'
import {motion} from 'framer-motion'

function MahsoolGuide({scrollRef}) {
  return (
    <div className="w-full  lg:h-fit lg:min-h-screen mt-9  lg:bg-mahsoolGuide-background  lg:bg-no-repeat  lg:bg-cover">
      <motion.div
              ref={scrollRef}
              initial={{ opacity: 0, y: -75 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ root: scrollRef, once: true }} className="  flex  lg:flex-row flex-col  lg:justify-center lg:gap-[35rem] lg:pt-36 lg:px-24">
        <div className=" mx-auto flex-row-reverse gap-1 flex my-9 lg:hidden">
          <span className="text-4xl font-semibold text-primary">مرشد </span>
          <span className="text-4xl font-semibold text-primary">محصول</span>
        </div>
        <div className="lg:hidden md:hidden h-[12.5rem] -z-50">
          <img src={background} alt="" className="scale-125" />
        </div>
        <div className="lg:hidden md:block hidden -z-50">
          <img src={background} alt="" className="" />
        </div>
        <div
          dir="rtl"
          className="mx-auto lg:mx-0 px-11 lg:px-0 mt-5 lg:mt-0 lg:w-80 text-right"
        >
          <p className="lg:text-2xl text-base text-center lg:text-right  mt-5  lg:mt-0 font-bold lg:font-medium">
            <span className=" lg:hidden">
              نقدم لك المعرفة والنصائح الهامة لجعل زراعتك أكثر نجاحًا .
            </span>
            استفد من خبرات خبرائنا في مجال الزراعة واحصل على استشارات مخصصة
            لاحتياجات مزرعتك
          </p>
          <Link to="/home/mahsool-guide">
            <div className="w-[11rem] bg-primary mx-auto lg:mx-0 text-center  mt-8 lg:mt-4  text-white font-bold p-3 rounded-[17.5px]">
              إعرف المزيد
            </div>
          </Link>
        </div>

        <div className="lg:flex flex-col lg:w-96 text-right hidden">
          <div className=" lg:flex-col flex-row-reverse flex ">
            <span className="text-6xl font-semibold text-primary">مرشد </span>
            <span className="text-6xl font-semibold text-primary">محصول</span>
          </div>

          <span className="text-2xl font-medium mt-6 ">
            نقدم لك المعرفة والنصائح الهامة لجعل زراعتك أكثر نجاحًا
          </span>
        </div>
      </motion.div>
    </div>
  );
}

export default MahsoolGuide;
